export default blockArchivesMenu => {
    // console.log('blockArchivesMenu');
    const sectionsMenu = blockArchivesMenu.querySelector('.sections-menu');
    const sectionsMenuItemsLink = sectionsMenu.querySelectorAll('.sections-menu-item .sections-menu-item-link');
    //const sections = document.querySelectorAll('.section.archives');

    /*function reveal(items, onreveal, offset = 0) {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.intersectionRatio > offset) {
                    onreveal(entry.target);
                    // observer.unobserve(entry.target);
                }
            });
        }, { threshold: offset });

        items.forEach(item => observer.observe(item));
    }

    function goTo(event) {
        const goto = event.target.getAttribute('data-goto');

        if (goto !== null) {
            document.getElementById(goto).scrollIntoView();
        }
    }

    reveal(sections, element => {
        const selectedMenuItem = Array.from(sectionsMenuItemsLink).find((item) => item.getAttribute('data-goto') === element.id);

        for (let i = 0; i < sectionsMenuItemsLink.length; i++) {
            sectionsMenuItemsLink[i].parentNode.classList.remove('active');
        }
        if (selectedMenuItem !== undefined) {
            selectedMenuItem.parentNode.classList.add('active');
        }
    }, 0);

    for (let i = 0; i < sectionsMenuItemsLink.length; i++) {
        sectionsMenuItemsLink[i].addEventListener('click', goTo);
    }*/

    let $anchors = [];

    for (let i = 0; i < sectionsMenuItemsLink.length; i++) {
        let $anchorLink = sectionsMenuItemsLink[i].getAttribute('data-goto');
        $anchors.push($anchorLink);
    };

    document.addEventListener("scroll", function () {
        let currentScroll = (document.documentElement["scrollTop"] || document.body["scrollTop"]);

        $anchors.forEach(function (item) {

            let sectionRect = document.querySelector('#' + item).getBoundingClientRect(),
                sectionTop = sectionRect.top,
                sectionBottom = sectionRect.bottom,
                headerSticky = document.querySelector('.main-header.sticky');

            sectionTop -= typeof (headerSticky) != 'undefined' && headerSticky != null ? headerSticky.offsetHeight : 0;

            if (sectionBottom < currentScroll >= sectionTop) {

                sectionsMenuItemsLink.forEach(function (link) {
                    link.parentNode.classList.remove('active');
                });
                //sectionsMenuItemsLink.classList.remove('active');
                document.querySelector('.sections-menu-item-link[data-goto="' + item + '"]').parentNode.classList.add('active');
            } else {

                //sectionsMenuItemsLink.classList.remove('active');
            }
        })


    });

    for (let i = 0; i < sectionsMenuItemsLink.length; i++) {
        sectionsMenuItemsLink[i].addEventListener('click', goTo);
    }

    function goTo(event) {
        const goto = event.target.getAttribute('data-goto');

        if (goto !== null) {
            event.preventDefault();
            let headerSticky = document.querySelector('.main-header.sticky');
            let headerStickyHeight = typeof (headerSticky) != 'undefined' && headerSticky != null ? headerSticky.offsetHeight : document.querySelector('.main-header').offsetHeight;

            let section = document.getElementById(goto);
            let offset = section.getBoundingClientRect().top + window.pageYOffset - headerStickyHeight;

            window.scrollTo({ top: offset, behavior: 'smooth' });
        }
    }


    // Calculate archivesMenu Height
    let archivesMenuChildren = blockArchivesMenu.children;
    let archivesMenuHeight = 0

    for (var i = 0; i < archivesMenuChildren.length; i++) {
        var childrenHeight = archivesMenuChildren[i].offsetHeight;
        childrenHeight += parseInt(window.getComputedStyle(archivesMenuChildren[i]).getPropertyValue('margin-top'));
        childrenHeight += parseInt(window.getComputedStyle(archivesMenuChildren[i]).getPropertyValue('margin-bottom'));
        archivesMenuHeight += childrenHeight;
    }
    document.querySelector('.block-archives-menu-container.desktop').style.height = archivesMenuHeight + 'px';
};
